import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';

const Filter = ({ value, onFilter }) => (
  <div style={{ whiteSpace: 'nowrap', flex: '1' }}>
    <Input
      prefix={<Icon type="search" style={{ color: 'rgba(255,255,255,.25)' }} />}
      onChange={onFilter}
      placeholder="Search..."
    />
  </div>
);

export default Filter;
